import { NO_API_RESPONSE_ERROR_MESSAGE } from 'constants/video/videoselfie';

export const serviceResponseMapper = response => {
    if (!response.ok || !response.body) {
        return { ok: false, errorMessage: NO_API_RESPONSE_ERROR_MESSAGE };
    }

    return { ok: true, data: response.body };
};
